import { reviews } from '@/mocks/homepage';

const avatarImages = [
  "https://readdy.ai/api/search-image?query=Professional%20modern%20portrait%20of%20a%20young%20European%20man%20with%20short%20brown%20hair%20warm%20friendly%20expression%20soft%20natural%20studio%20lighting%20on%20a%20warm%20ivory%20background%20clean%20minimal%20aesthetic%20authentic%20personality%20headshot&width=80&height=80&seq=avatar-lukas-v2&orientation=squarish",
  "https://readdy.ai/api/search-image?query=Professional%20modern%20portrait%20of%20a%20young%20European%20woman%20with%20shoulder%20length%20blonde%20hair%20gentle%20smile%20soft%20diffused%20studio%20lighting%20on%20a%20warm%20sand%20colored%20background%20clean%20minimal%20aesthetic%20authentic%20warmth%20headshot&width=80&height=80&seq=avatar-sophie-v2&orientation=squarish",
  "https://readdy.ai/api/search-image?query=Professional%20modern%20portrait%20of%20a%20European%20man%20in%20his%20early%20thirties%20with%20neat%20beard%20confident%20expression%20soft%20natural%20studio%20lighting%20on%20a%20warm%20greige%20background%20clean%20minimal%20aesthetic%20trustworthy%20appearance%20headshot&width=80&height=80&seq=avatar-max-v2&orientation=squarish",
  "https://readdy.ai/api/search-image?query=Professional%20modern%20portrait%20of%20a%20young%20European%20woman%20with%20dark%20wavy%20hair%20bright%20genuine%20smile%20soft%20natural%20studio%20lighting%20on%20a%20warm%20cream%20background%20clean%20minimal%20aesthetic%20friendly%20approachable%20headshot&width=80&height=80&seq=avatar-anna-v2&orientation=squarish",
  "https://readdy.ai/api/search-image?query=Professional%20modern%20portrait%20of%20a%20European%20man%20in%20his%20twenties%20with%20styled%20hair%20relaxed%20casual%20expression%20soft%20diffused%20studio%20lighting%20on%20a%20warm%20beige%20background%20clean%20minimal%20aesthetic%20modern%20professional%20headshot&width=80&height=80&seq=avatar-felix-v2&orientation=squarish",
  "https://readdy.ai/api/search-image?query=Professional%20modern%20portrait%20of%20a%20young%20European%20woman%20with%20auburn%20hair%20thoughtful%20warm%20expression%20soft%20natural%20studio%20lighting%20on%20a%20warm%20ecru%20background%20clean%20minimal%20aesthetic%20genuine%20authentic%20headshot&width=80&height=80&seq=avatar-julia-v2&orientation=squarish",
];

const stars = (rating: number) => {
  return Array.from({ length: 5 }, (_, i) => (
    <i key={i} className={`text-xs ${i < rating ? 'ri-star-fill text-accent-500' : 'ri-star-line text-foreground-300'}`}></i>
  ));
};

export default function ReviewsSection() {
  return (
    <section id="bewertungen" className="py-14 md:py-20 px-4 md:px-6 lg:px-10 bg-background-100">
      <div className="max-w-7xl mx-auto">
        <div className="mb-10">
          <span className="inline-block px-3 py-1 mb-3 text-xs font-medium tracking-wider uppercase rounded-full bg-accent-100 text-accent-700">
            Echte Erfahrungen
          </span>
          <h2 className="text-3xl md:text-4xl font-heading font-semibold text-foreground-900 leading-tight">
            Was deutsche Käufer über<br />das Oopbuy Spreadsheet sagen
          </h2>
        </div>

        <div className="columns-1 md:columns-2 lg:columns-3 gap-5 md:gap-6 space-y-5 md:space-y-6">
          {reviews.map((review, idx) => (
            <div key={review.username} className="break-inside-avoid bg-background-50 rounded-xl p-5 md:p-6">
              <div className="flex items-center gap-3 mb-3">
                <div className="w-10 h-10 rounded-full overflow-hidden flex-shrink-0 bg-secondary-100">
                  <img
                    src={avatarImages[idx]}
                    alt={review.name}
                    className="w-full h-full object-cover"
                    loading="lazy"
                  />
                </div>
                <div>
                  <div className="text-sm font-semibold text-foreground-900">{review.name}</div>
                  <div className="text-xs text-foreground-500">{review.username}</div>
                </div>
              </div>
              <div className="flex gap-0.5 mb-3">
                {stars(review.rating)}
              </div>
              <p className="text-sm text-foreground-700 leading-relaxed">
                &ldquo;{review.text}&rdquo;
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}